<template>
    <div class="qksm qksm8">
        <h4>八、政府性基金预算财政拨款收入支出决算情况说明</h4>
        <p v-if="T8.年初结转结余==0 && T8.本年收入==0 && T8.本年支出==0 && T8.年末结转和结余==0">
            本{{$parent.typeText}}没有政府性基金财政拨款收支。
        </p>
        <div class="nogap" v-else>
            <p>
                2021年度政府性基金预算财政拨款年初结转和结余{{isMoney(T8.年初结转结余)}}万元，本年收入{{isMoney(T8.本年收入)}}万元，
                本年支出{{isMoney(T8.本年支出)}}万元，年末结转和结余{{isMoney(T8.年末结转和结余)}}万元。
                <template v-if="T8.items.length>0">
                    支出具体情况如下：
                </template>
            </p>
            <p v-for="(item,idx) in (T8.items)" :key="idx">
                {{T8.items.length>1 ? "（"+intToChinese(idx+1)+"）" :""}}{{item.lei}}{{item.kuan}}{{item.xiang}}。年初预算为
                <reason type="money" classname="qksm money beginYear" :name="item.code+'政府预算'" v-model:value="item.value_ys"></reason>万元，支出决算为{{isMoney(item.value)}}万元，
                <span v-if="num(item.value_ys)==0">年初无预算。</span>
                <template v-if="num(item.value_ys).toFixed(2)==num(item.value).toFixed(2)">
                    完成年初预算的100%，决算数与年初预算数基本持平。
                </template>
                <template v-else>
                    <template v-if="num(item.value_ys)!=0">
                        完成年初预算的{{calcRatio(item.value,item.value_ys)}}。
                    </template>
                    决算数{{num(item.value)>num(item.value_ys) ? "大于" : "小于"}}年初预算数主要原因是
                    <reason type="textarea" classname="qksm widest because" :name="item.code+'政府原因'" v-model:value="qksm[item.code+'政府原因']"></reason>
                </template>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm8",
        props: {
            T8: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        data() {
            var qksm = this.$store.state.divData.qksm;
            for (let a of this.T8.items) {
                let v = qksm[a.code + '政府预算'];
                if (v)
                    a.value_ys = v;
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
            }
        },
    };
</script>
